import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useEffect, useState } from "react";
const Sponsoring = () => {
  const { t } = useTranslation("contact");
  const [direction, setDirection] = useState("ltr");

  useEffect(() => {
    setDirection(document?.documentElement?.dir);
  }, []);
  return (
    <div
      style={{
        textAlign: "justify",
        textJustify: "inter-word",
      }}
      className="flex flex-col gap-y-6 my-20 m-auto w-[90%] md:w-[80%] lg:w-[70%]"
    >
      <h2 className="text-4xl text-[#233377]">Privacy Policy </h2>
      <h3 className="text-3xl text-[#233377]" dir="ltr">
        1. Description of Service
      </h3>
      <p dir="ltr">
        This privacy policy aims to inform you about the collection, storage, and usage of your
        information by Yawakit (&quot;us&quot;, &quot;we&quot;) when you use our service. We take
        your privacy seriously and do not share, sell, or rent your personal information to any
        third party unless otherwise mentioned below. We may periodically update this privacy
        policy, and as a registered user of Yawakit, we will try to notify you of any significant
        changes through email. Otherwise, please check the Yawakit platform frequently for the
        latest and most accurate privacy policy. If you have previously provided us with personal
        information, you may review, remove, or modify it under the Data Protection Act 1998 by
        directly contacting us via email.
      </p>
      <h2 className="text-3xl text-[#233377]" dir="ltr">
        2. Data Collection & Use
      </h2>
      <p dir="ltr">
        At Yawakit, we only gather the personal information that you voluntarily provide during the
        registration process. To utilize our services, you must provide us with your Full Name,
        Address, Email Address, Phone, Country, State, and Zip Code during the registration process.
        You have the option to choose not to share any of the above information, but doing so will
        prevent you from using certain features or Yawakit services. Once you delete your account,
        we will retain your data for 30 days before fully removing it from our system.
      </p>
      <h2 className="text-3xl text-[#233377]" dir="ltr">
        3. Analytics
      </h2>
      <p dir="ltr">
        Yawakit may gather and retain particular details about your engagement with our website and
        services, such as cookies, IP addresses, browser and device types, location, entry and exit
        pages, operating systems, internet service providers (ISPs), time and date stamps, and other
        related data. We utilize this data solely to enhance the quality of our services and
        products. If you decide to decline cookies through your browser, some limitations may apply
        when using Yawakit services.
      </p>
      <h2 className="text-3xl text-[#233377]" dir="ltr">
        4. Email Notices
      </h2>
      <p dir="ltr">
        After registering for Yawakit services, your email address will be automatically included in
        the Yawakit mailing list. This list is used to send you welcome information, account
        details, and other marketing-related communications related to Yawakit services and the
        products you have viewed or purchased. We may also periodically send you emails notifying
        you of new features, products, titles, and other relevant information regarding Yawakit
        services. You have the option to opt-out of receiving emails from Yawakit. However, if you
        do so, you will not receive technical support requests, account updates and notifications,
        product updates, security updates, or updates to the Terms of Services or Privacy Policy of
        Sweiq.
      </p>
      <h2 className="text-3xl text-[#233377]" dir="ltr">
        5. Security
      </h2>
      <p dir="ltr">
        We take reasonable measures to safeguard your personal information against unauthorized
        access, use, alteration, or destruction. We have implemented various security technologies
        and procedures to protect your data from unauthorized access, improper use or disclosure,
        and accidental loss or destruction. We cannot, however, guarantee the absolute security of
        any data transmitted over the internet or any wireless network. As such, we encourage you to
        take appropriate measures to protect yourself, such as using a strong password and not
        sharing your login information with anyone. If you suspect any unauthorized access or misuse
        of your account, please notify us immediately. Changes to our privacy policy We will post
        any future changes to our Privacy Policy on this page, and we may also notify you of any
        significant updates via email when appropriate.
      </p>
      <h2 className="text-3xl text-[#233377]" dir="ltr">
        6. Your Rights
      </h2>
      <p dir="ltr">
        You have the right to request that we do not process your personal data for marketing
        purposes. If you wish to exercise this right, please contact us at contact@yawakit.com.
        Contact Information If you have any questions or concerns about this policy or any Yawakit
        services products, services or features, please don’t hesitate to contact us at
        contact@yawakit.com We collect and process user data for the following purposes:
      </p>
      <h3 className="text-1xl text-[#233377]" dir="ltr">
        {" "}
        Email Address:
      </h3>
      <p dir="ltr">
        We collect your email address to: Create and manage your account. Send you important
        account-related updates and notifications. Provide customer support and respond to your
        inquiries. Your email will not be shared with third parties without your consent.
      </p>
      <h3 className="text-1xl text-[#233377]" dir="ltr">
        {" "}
        Profile Picture (Avatar):
      </h3>
      <p dir="ltr">
        We collect your profile picture to: Personalize your account experience. Display your avatar
        in the user interface, such as in comments or profile pages. Your avatar will only be
        visible to other users where applicable (e.g., in public posts).
      </p>
      <h2 className="text-3xl text-[#233377]" dir="ltr">
        7. Account Deletion{" "}
      </h2>
      <p dir="ltr">
        If you wish to have your account or personal data removed from our system, you can send an
        email to contact@yawakit.com with the subject line &quot;Account Deletion Request.&quot;
        Please include your account information (e.g., username or email address associated with the
        account) to help us locate your data. We will process your request within 10 working days
        and notify you once the deletion is complete.
      </p>
    </div>
  );
};

export default Sponsoring;

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "hero",
        "layout",
        "about",
        "contact",
        "categories",
        "signup_promotion",
      ])),
    },
  };
}
